import type { PathParams } from './path-params';
import type { Route } from './routes';
export { getRouteOwner, isHydraRoute } from './route-ownership';

/**
 * @deprecated Use only for embedded/manual routes that still live in `ROUTES`.
 * For TanStack-owned Hydra routes, use `router.buildLocation(...)` instead.
 */
export function generatePath<Path extends Route>(
  path: Path,
  params: PathParams<Path>,
  query?: Record<string, string | number | boolean | undefined | null>,
  hash?: string,
): string {
  const base = path.replace(/:([^/]+)/g, (_, key: string) => {
    const value = params[key as keyof typeof params];
    if (value == null) {
      throw new Error(`Missing ":${key}" param`);
    }

    return String(value);
  });

  const searchParams = new URLSearchParams();
  if (query != null) {
    for (const [key, value] of Object.entries(query)) {
      if (value != null) {
        searchParams.set(key, String(value));
      }
    }
  }

  const search = searchParams.toString();
  const withSearch = search.length > 0 ? `${base}?${search}` : base;
  return hash != null ? `${withSearch}#${hash}` : withSearch;
}
